/**
 * What post-processing itself adds to a room at scan time: the `addedBy` of
 * every object the scan pipeline makes rather than a person or a design. One
 * list for the scanned label's backfill (`backfill.js`) and the
 * existing-conditions inspection (`existing-conditions/existingObjects.js`),
 * which had each kept a copy and drifted apart — the inspection's lacked
 * `dropped-vanity-check`, so a basin RoomPlan dropped and the pipeline
 * recovered was never inspected. Its own module, with no requires, so the web
 * can read it without the backfill's planning code.
 */

/**
 * The pipeline's light and switch grid: both a scan-time pass and a user tool.
 * Before the label existed nothing told them apart, and the scan-time grid is
 * on every scan, so the label counts them as scanned. The inspection does not:
 * the scanner captures no lights, and the grid is the pipeline's guess
 * (the user, 2026-10-15).
 */
const GRID_PRODUCERS = new Set(['add_lighting', 'add_switches']);

/**
 * The bathroom pass's tub and shower: `bathroom-post-processing` replaces a
 * scanned tub or shower with an assembly built by the same tools a design
 * uses, so the scan's own tub, its faucet, showerhead and controls carry the
 * TOOL's name. Like the grid, nothing older than the label tells the two
 * apart, so the label counts them as scanned — left off, a scan's bathtub
 * read as new work in 29 of the 56 corpus structures (issue #2690). The risk
 * it accepts: a tub a user designed before the label existed reads as
 * existing. The inspection does not take them: it reads the current rooms,
 * design included, and would ask the walkthrough about a designed tub.
 */
const BATH_ASSEMBLY_PRODUCERS = new Set([
  'create_bathroom_tub',
  'create_bathroom_shower',
]);

const PIPELINE_PRODUCERS = new Set([
  'scan-run-materialize',
  'scan-island-materialize',
  'kitchen-post-processing',
  'bathroom-post-processing',
  'design-adjustments',
  'dropped-vanity-check',
  ...GRID_PRODUCERS,
  ...BATH_ASSEMBLY_PRODUCERS,
]);

module.exports = {
  PIPELINE_PRODUCERS,
  GRID_PRODUCERS,
  BATH_ASSEMBLY_PRODUCERS,
};
